import { Component, Fragment } from "react";
import {
  DKLabel,
  DKIcons,
  DKButton,
  DKListPicker,
  INPUT_TYPE,
  showAlert,
} from "deskera-ui-library";
// import { PipelineManager } from "../../../managers/PipelineManager";
import {
  AUTOMATION_ACTIONS,
  SPLIT_ACTION_TYPE,
  SPLIT_ACTION_TYPE_CONTEXT,
} from "../AutomationConstants";
import { TableManger, TABLES } from "../../../managers/TableManger";
import Utility from "../../../utility/Utility";
import { FieldRow } from "./FieldMapper";
import AttendanceService from "../../../services/AttendanceService";
import { PipelineManager } from "../../../managers/PipelineManager";
import i18next from "i18next";

/* PROPS:
 - stepData
 - parentStepId
 - parentStepType
 - onSave
 - onClose
*/

class SplitActionPopup extends Component {
  designations={}
  constructor(props) {
    super(props);
    
    this.pipelineDetails = PipelineManager.processPipelineData();
    this.defaultLogicalOperator = "or";
    this.supportedConditionTypes = Object.keys(SPLIT_ACTION_TYPE).filter(
      (actionType) =>
        SPLIT_ACTION_TYPE_CONTEXT[SPLIT_ACTION_TYPE[actionType]].includes(
          props.parentStepType
        )
    );

    this.state = {
      activeType: null,
      columns: {},
      needEmailConfigSelection: false,
      logicalOperator: this.initializeOperators() /* [type]: "or" / "and" */,
      configuration:
        this.initializeConfig() /* { [type]: {[fieldId]: {value: "", opr: "eq"}} }*/,
    };

    this.state.activeType =
      Object.keys(this.state.configuration)[0] ||
      this.supportedConditionTypes[0];
  }

  componentDidMount() {
    this.getDesignations();
  }
  getDesignations(){
    AttendanceService.getDesignation().then(response=>{
      if(response['designations']) {
        let designationFilteredList = response['designations'].filter(res=>res !="");
        let designColumn = {}
        designationFilteredList.forEach(obj=>{
          designColumn[obj] = {
            id:obj,
            key:obj,
            value:obj,
            name:obj,
            splitConfigType:SPLIT_ACTION_TYPE.DESIGNATION
          }
        })
        this.designations = designColumn
        this.setFieldsData();
      }      
    },error=>{
      console.log(error)
    });
  }
  initializeConfig() {
    const { stepData } = this.props;

    const newConfiguration = {};
    if (this.props.stepData?.type === AUTOMATION_ACTIONS.SPLIT_WORKFLOW) {
      stepData?.configuration?.forEach((configTypeData) => {
        const newFields = {};
        configTypeData.fields.forEach((fieldData) => {
          const opr = fieldData.opr || "eq";
          delete fieldData[opr];
          const fieldKey = Object.keys(fieldData)[0];
          const value = fieldData[fieldKey];
          if (fieldKey === "nodeKey") return;
          newFields[fieldKey] = { value: value, opr: opr };
        });
        newConfiguration[configTypeData.type] = newFields;
      });
    } else {
      let configTypeData = stepData?.configuration
      const newFields = {};
      if(configTypeData) {
        configTypeData.fields.forEach((fieldData) => {
          const opr = fieldData.opr || "eq";
          delete fieldData[opr];
          const fieldKey = Object.keys(fieldData)[0];
          const value = fieldData[fieldKey];
          if (fieldKey === "nodeKey") return;
          newFields[fieldKey] = { value: value, opr: opr };
        });
        newConfiguration[configTypeData.type] = newFields;
      }
    }

    return newConfiguration;
  }

  initializeOperators() {
    const { stepData } = this.props;
    const newOperators = {};
    if (this.props.stepData?.type === AUTOMATION_ACTIONS.SPLIT_WORKFLOW) {
      stepData?.configuration?.forEach((configTypeData) => {
        if (configTypeData.logicalOperator) {
          newOperators[configTypeData.type] = configTypeData.logicalOperator;
        }
      });
    } else {
      if (stepData?.configuration?.logicalOperator) {
        newOperators[stepData.configuration.type] = stepData.configuration.logicalOperator;
      }
    }

    return newOperators;
  }

  ////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////
  /////////////////////FIELD HANDLERS/////////////////////////
  getColumnFilterFunc(column) {
    let returnVal = false;
    if (column.uiVisible && column.type !== INPUT_TYPE.DATE) returnVal = true;
    if (TableManger.isSelectField(column) && column.options.length === 0)
      returnVal = false;
    return returnVal;
  }

  addField(column) {
    const newConfiguration = Utility.makeCopyOfObject(this.state.configuration);
    newConfiguration[this.state.activeType] =
      newConfiguration[this.state.activeType] || {};
    newConfiguration[this.state.activeType][column.id] = {
      value: TableManger.isSelectField(column) ? column.options[0].id : "",
      opr: "eq",
    };
    this.setState({
      configuration: newConfiguration,
    });
  }

  showRandomField(visibleFields = []) {
    const { columns } = this.state;
    Object.keys(columns).some((key) => {
      if (visibleFields.includes(key)) return false;

      this.addField(columns[key]);
      return true;
    });
  }

  setFieldsData() {
    const { activeType } = this.state;

    let newColumns = {};
    switch (activeType) {
      case SPLIT_ACTION_TYPE.DESIGNATION_CHECK:
        // let contactColumn = TableManger.getTableFilteredColumns(
        //   TABLES.CANDIDATE,
        //   this.getColumnFilterFunc,
        //   false
        // );
        
        newColumns = this.designations;
        break;
      case SPLIT_ACTION_TYPE.DEAL_CHECK:
        const dealColumns = TableManger.getTableFilteredColumns(
          TABLES.PIPELINE,
          this.getColumnFilterFunc,
          false
        );
        dealColumns.forEach((column) => {
          newColumns[column.id] = Utility.makeCopyOfObject(column);
        });
        break;
      case SPLIT_ACTION_TYPE.EMAIL_OPENED:
      case SPLIT_ACTION_TYPE.EMAIL_LINK_CLICKED:
        /* Custom field for storing user preference */
        newColumns = {
          viewCount_1: {
            id: "viewCount_1",
            key: "viewCount",
            value: 1,
            name: "Email has been opened",
            splitConfigType: SPLIT_ACTION_TYPE.EMAIL_OPENED,
          },
          viewCount_0: {
            id: "viewCount_0",
            key: "viewCount",
            value: 0,
            name: "Email has not been opened",
            splitConfigType: SPLIT_ACTION_TYPE.EMAIL_OPENED,
          },
          clickCount_1: {
            id: "clickCount_1",
            key: "clickCount",
            value: 1,
            name: "Email link has been clicked",
            splitConfigType: SPLIT_ACTION_TYPE.EMAIL_LINK_CLICKED,
          },
          clickCount_0: {
            id: "clickCount_0",
            key: "clickCount",
            value: 0,
            name: "Email link has not been clicked",
            splitConfigType: SPLIT_ACTION_TYPE.EMAIL_LINK_CLICKED,
          },
        };
        break;
      default:
    }

    this.setState(
      { columns: newColumns }
      // ,() => {
      // if (!configuration[activeType]) {
      //   this.showRandomField();
      // }
      // }
    );
  }

  onFieldUpdate = (fieldKey, valueType, token, newField, oldField) => {
    const newConfiguration = Utility.makeCopyOfObject(this.state.configuration);

    if (oldField) {
      const newKey = Object.keys(newField)[0];
      newConfiguration[this.state.activeType] = this.reorderFields(
        newConfiguration[this.state.activeType],
        fieldKey,
        newKey,
        newField[newKey]
      );
    } else {
      newConfiguration[this.state.activeType] =
        newConfiguration[this.state.activeType] || {};
      newConfiguration[this.state.activeType][fieldKey] =
        newConfiguration[this.state.activeType][fieldKey] || {};

      newConfiguration[this.state.activeType][fieldKey][valueType] = token;
    }

    this.setState({ configuration: newConfiguration });
  };

  reorderFields(fields, oldKey, newKey, newValue) {
    let newFields = {};
    Object.keys(fields).forEach((key) => {
      if (key === oldKey) {
        newFields[newKey] = { value: newValue, opr: "eq" };
      } else {
        newFields[key] = fields[key];
      }
    });
    return newFields;
  }

  onFieldRemove = (fieldKey) => {
    const newConfiguration = Utility.makeCopyOfObject(this.state.configuration);
    delete newConfiguration[this.state.activeType][fieldKey];
    this.setState({ configuration: newConfiguration });
  };

  handleOperatorChange = (newOperator) => {
    this.setState((prevState) => ({
      logicalOperator: {
        ...prevState.logicalOperator,
        [this.state.activeType]: newOperator,
      },
    }));
  };

  ////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////
  //////////////////////POPUP HANDLERS////////////////////////
  onSave = () => {
    const { configuration, logicalOperator } = this.state;

    const newConfiguration = Object.keys(configuration)
      .map((configType) => {
        const fields = configuration[configType];
        const newFields = Object.keys(fields).map((fieldKey) => ({
          [fieldKey]: fieldKey,
          designation:fieldKey,
          opr: fields[fieldKey].opr || "eq",
        }));

        newFields.push({
          nodeKey: this.props.parentStepId,
        });

        return {
          type: configType,
          fields: newFields,
          logicalOperator:
            logicalOperator[configType] || this.defaultLogicalOperator,
        };
      })
      .filter(
        (config) =>
          config.fields.filter((field) => !("nodeKey" in field))?.length
      );

    if (newConfiguration.length) {
      const isEmailTypeConfig =
        this.state.activeType === SPLIT_ACTION_TYPE.EMAIL_OPENED ||
        this.state.activeType === SPLIT_ACTION_TYPE.EMAIL_LINK_CLICKED;
      const config = this.props.stepData?.type === AUTOMATION_ACTIONS.SPLIT_WORKFLOW ? newConfiguration : newConfiguration[0]
      this.props.onSave(config, isEmailTypeConfig);
    } else {
      showAlert(
        `Can't save split node?`,
        `Please provide at least one condition to split workflow into two branches.`
      );
    }
  };

  ////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////
  //////////////////////RENDERERS/////////////////////////////

  render() {
    return (
      <div className="transparent-background">
        <div
          className="popup-window"
          style={{
            padding: 0,
            maxWidth: 450,
            maxHeight: "90%",
            overflowY: "visible",
          }}
        >
          {this.renderHeader()}
          {this.renderBody()}
          {this.renderBottom()}
        </div>
      </div>
    );
  }

  renderHeader() {
    return (
      <div className="row justify-content-between bg-gray3 p-m">
        <DKLabel text={this.state.activeType==SPLIT_ACTION_TYPE.DESIGNATION_CHECK ? `${this.props?.stepData?.title} ${i18next.t('OPTIONS')}`:i18next.t('SPLIT_OPTION')} className="fw-m" />
        <DKButton
          icon={DKIcons.ic_close}
          onClick={() => this.props.onClose()}
        />
      </div>
    );
  }

  renderBody() {
    const isEmailTypeConfig =
      this.state.activeType === SPLIT_ACTION_TYPE.EMAIL_OPENED ||
      this.state.activeType === SPLIT_ACTION_TYPE.EMAIL_LINK_CLICKED;
    return (
      <div
        className="column align-items-start parent-width p-m hide-scroll-bar"
        style={{ height: "90%", overflowY: "visible" }}
      >
        {/* {this.renderConfigTypes()} */}
        {isEmailTypeConfig
          ? this.renderEmailTypeConfigOptions()
          : this.renderConfigOptions()}
      </div>
    );
  }

  renderConfigTypes() {
    return (
      <Fragment>
        <DKLabel
          text="Apply options from any type(s) below for splitting workflow actions."
          className="p-h-s border-box fs-r parent-width"
        />
        <div
          className="row width-auto mt-l mb-r border-m border-radius-m hide-scroll-bar"
          style={{ overflow: "auto hidden", flexShrink: 0 }}
        >
          {this.supportedConditionTypes.map((actionType, index) => {
            const actionTypeValue = SPLIT_ACTION_TYPE[actionType];
            const isActiveType = this.state.activeType === actionTypeValue;
            return (
              <DKButton
                key={actionType}
                title={actionTypeValue}
                className={`fs-s fw-m border-radius-none ${
                  isActiveType ? "bg-button text-white" : ""
                }`}
                style={{
                  borderLeft: index === 0 ? "none" : "1px solid #dcdcdc",
                }}
                onClick={() => {
                  this.setState(
                    {
                      columns: {},
                      activeType: actionTypeValue,
                    },
                    this.setFieldsData
                  );
                }}
              />
            );
          })}
        </div>
      </Fragment>
    );
  }

  renderConfigOptions() {
    const { columns, activeType, configuration, logicalOperator } = this.state;
    if (!columns || !Object.keys(columns).length)
      return (
        <div className="row bg-gray1 border-m border-radius-m mt-m p-s">
          Job titles are not available, please check employee profile.
        </div>
      );

    const fields = configuration[activeType] || {};
    const fieldKeys = Object.keys(fields);

    const fieldMap = {};
    fieldKeys.forEach((field) => {
      fieldMap[field] = fields[field].value;
    });

    return (
      <Fragment>
        <div
          className={`${activeType==SPLIT_ACTION_TYPE.DESIGNATION_CHECK ? "custom-scroll field-row-align":"" } parent-width border-box p-h-xs`}
          style={{ minHeight: 150 }}
        >
          {fieldKeys?.length ? (
            fieldKeys.map((fieldKey) => (
              <FieldRow
                type={this.props.stepData.type}
                columns={columns}
                elementType={this.props.stepData.elementType}
                field={fieldKey}
                fields={fieldMap}
                operator={fields[fieldKey].opr}
                isSingleCondition={true}
                onChange={(newField, oldField) =>
                  this.onFieldUpdate(
                    fieldKey,
                    "value",
                    newField[fieldKey],
                    newField,
                    oldField
                  )
                }
                onConditionChange={(opr) =>
                  this.onFieldUpdate(fieldKey, "opr", opr)
                }
                onFieldRemove={() => this.onFieldRemove(fieldKey)}
                isFieldAlign={activeType==SPLIT_ACTION_TYPE.DESIGNATION_CHECK}
              />
            ))
          ) : (
            <DKLabel
              text="No condition is applied for the current type, please add a condition from below."
              className="bg-gray1 mt-l p-r border-radius-m parent-width border-box"
            />
          )}
        </div>
        {fieldKeys.length > 1
          ? this.renderLogicalOperatorButtons(
              logicalOperator[activeType] || this.defaultLogicalOperator
            )
          : null}
        {fieldKeys.length < Object.keys(columns).length ? (
          <DKButton
            title={`+ Add ${
              fieldKeys.length === 0 ? "a" : "another"
            } condition`}
            className="align-self-start text-blue fw-m"
            style={{ marginTop: "auto", paddingBottom: 0, paddingLeft: 0 }}
            onClick={() => this.showRandomField(fieldKeys)}
          />
        ) : null}
      </Fragment>
    );
  }

  renderLogicalOperatorButtons(activeOperator) {
    return (
      <div className="align-self-center row width-auto mt-r bg-white border-m shadow-s-2 border-radius-s">
        {/* <div
          className="cursor-hand"
          onClick={() => this.handleOperatorChange("and")}
        >
          <DKLabel
            text="And"
            className={
              "p-v-xs p-h-s " +
              (activeOperator === "and" ? "bg-gray1 fw-m" : "text-gray")
            }
          />
        </div> */}
        <div
          className="cursor-hand"
          onClick={() => this.handleOperatorChange("or")}
        >
          <DKLabel
            text="Or"
            className={
              "p-v-xs p-h-s " +
              (activeOperator === "or" ? "bg-gray1 fw-m" : "text-gray")
            }
          />
        </div>
      </div>
    );
  }

  renderEmailTypeConfigOptions() {
    const { columns, configuration, needEmailConfigSelection, activeType } =
      this.state;

    const currentOptionKey =
      configuration[activeType] && Object.keys(configuration[activeType])[0];
    const currentOptionValue =
      configuration[activeType] &&
      configuration[activeType][currentOptionKey].opr === "gt"
        ? 1
        : 0;

    const currentOptionColumnData = currentOptionKey
      ? columns[`${currentOptionKey}_${currentOptionValue}`]
      : null;

    return (
      <Fragment>
        <DKLabel
          text="How would you like to split the path?"
          className="p-h-s border-box fs-r parent-width"
        />
        <div
          className="column mt-l m-h-r position-relative"
          style={{ minHeight: 150 }}
        >
          <DKButton
            className={`${
              currentOptionColumnData ? "" : "text-red"
            } border-m split-email-config-button`}
            style={{ borderRadius: 6 }}
            title={currentOptionColumnData?.name || "Select a condition"}
            isReverse={true}
            icon={DKIcons.ic_arrow_down}
            onClick={() => {
              this.setState({ needEmailConfigSelection: true });
            }}
          />
          {needEmailConfigSelection ? (
            <DKListPicker
              data={Object.values(columns).map((columnData) => columnData.name)}
              className="position-absolute shadow-m border-m z-index-3"
              style={{ top: 0, left: 0, width: 250 }}
              onSelect={(index, option) => {
                const selectedFieldData = Object.values(columns).find(
                  (columnData) => option === columnData.name
                );

                this.setState({
                  activeType: selectedFieldData.splitConfigType,
                  configuration: {
                    [selectedFieldData.splitConfigType]: {
                      [selectedFieldData.key]: {
                        value: 0,
                        opr: selectedFieldData.value ? "gt" : "eq",
                      },
                    },
                  },
                });

                this.setState({
                  needEmailConfigSelection: false,
                });
              }}
              onClose={() => {
                this.setState({ needEmailConfigSelection: false });
              }}
            />
          ) : null}
          {currentOptionColumnData ? (
            <DKLabel
              text={`Further workflow will get evaluated based on condition: ${currentOptionColumnData.name.toLowerCase()}.`}
              className="mt-l p-s border-box fs-r border-m border-radius-s bg-gray1 parent-width"
            />
          ) : null}
        </div>
      </Fragment>
    );
  }

  renderBottom() {
    return (
      <div className="row-reverse pb-l p-h-l">
        <DKButton
          title="Save"
          className="bg-button text-white ml-m"
          onClick={() => this.onSave()}
        />

        <DKButton
          title="Cancel"
          className="bg-gray1 border-m"
          onClick={() => this.props.onClose()}
        />
      </div>
    );
  }
}

export default SplitActionPopup;
